<template>
  <div v-if="quest.goals && quest.goals.length > 0" :class="{drops_works_card: true, hub_completed_quest_card: isQuestComplete, hub_quest_card: !isQuestComplete}">
    <div v-if="quest.questType === QUEST_TYPE_SUBMIT_SCORE" class="drops_works_card_title card_title_underline hub_quest_title_submit_score">
      <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; word-break: break-word">
        <img v-if="isLightTheme && quest.allowShowSponsor && quest.sponsorImage" class="lazyload" :src="getSponsorLightTheme" style="min-width: 110px; width: 110px; height: 65px; object-fit: cover; margin-right: 8px;">
        <img v-else-if="!isLightTheme && quest.allowShowSponsor && quest.sponsorImageDark" class="lazyload" :src="getSponsorDarkTheme" style="min-width: 110px; width: 110px; height: 65px; object-fit: cover; margin-right: 8px;">
        {{ quest.title }}
        <div v-if="quest.questStatus === QUEST_STATUS_DOING" class="quest_title_status">{{ quest.endDate }}</div>
        <div v-else class="hub_quest_card_icon_status">
          <svg-icon v-if="quest.questStatus === QUEST_STATUS_APPROVED" name="quest-success" />
          <svg-icon v-if="quest.questStatus === QUEST_STATUS_DENIED" name="quest-fail" />
          <svg-icon v-if="quest.questStatus === QUEST_STATUS_PENDING" name="quest-pending" />
        </div>
      </div>
      <span class="hub_quest_description">{{ quest.goals[0].description }}</span>
    </div>
    <div v-if="quest.questType === QUEST_TYPE_QUESTION" class="drops_works_card_title card_title_underline hub_quest_title_question">
      <img v-if="isLightTheme && quest.allowShowSponsor && quest.sponsorImage" class="lazyload" :src="getSponsorLightTheme" style="width: 110px; height: 65px; object-fit: cover;">
      <img v-else-if="!isLightTheme && quest.allowShowSponsor && quest.sponsorImageDark" class="lazyload" :src="getSponsorDarkTheme" style="width: 110px; height: 65px; object-fit: cover;">
      {{ quest.title }}
      <div class="hub_quest_card_icon_status">
        <svg-icon v-if="quest.questStatus === QUEST_STATUS_APPROVED" name="quest-success" />
        <svg-icon v-if="quest.questStatus === QUEST_STATUS_DENIED" name="quest-fail" />
        <svg-icon v-if="quest.questStatus === QUEST_STATUS_PENDING" name="quest-pending" />
      </div>
    </div>
    <div v-if="quest.questType === QUEST_TYPE_SUBMIT_SCORE && !isQuestComplete" class="drops_works_card_lines hub_quest_card_lines hub_quest_submit_score">
      <div v-if="quest.goals[0].allowInput" class="hub_quest_card_line">
        <div class="quest_input_score">
          {{ quest.goals[0].textInput }}:
          <input v-model="scoreSubmit" :maxlength="100" type="text" name="input_score">
        </div>
      </div>
      <div v-if="quest.goals[0].allowUpload" class="hub_quest_card_line">
        <div class="quest_attach_image">
          <input id="quest_attach_file" type="file" accept=".jpg,.jpeg,.png,.gif" class="quest_attach_file" @change="handleChooseFile">
          <div class="quest_custom_button quest_custom_attach_file" :style="'background:' + hubDropsTheme">Upload Proof</div>
          <span class="quest_custom_attach_file_name"><abbr :title="fileNameUpload" style="text-decoration: unset;">{{ fileNameUpload }}</abbr></span>
        </div>
      </div>
    </div>
    <template v-if="quest.questType === QUEST_TYPE_QUESTION">
      <div
        v-for="(goal, idx) in quest.goals"
        :key="idx"
        class="drops_works_card_lines hub_quest_card_lines hub_quest_answer_question"
      >
        <div class="hub_quest_card_line hub_quest_question">
          {{ goal.description }}
        </div>
        <div class="hub_quest_card_line hub_quest_answers">
          <div
            v-for="(answer, index) in goal.answers"
            :key="index"
            :class="{hub_quest_answer: true, hub_completed_quest_answer: isQuestComplete, choosing: choosingAnswer.includes(answer), true_answer: isCorrectAnswer(answer, goal) && isChoseAnswer(answer, goal), fail_answer: !isCorrectAnswer(answer, goal) && isChoseAnswer(answer, goal)}"
            @click.stop.prevent="handleChooseAnswer(answer, goal)"
          >
            {{ answer }}
            <svg-icon v-if="isCorrectAnswer(answer, goal) && isChoseAnswer(answer, goal)" style="margin-left: 10px" name="tick" />
            <svg-icon v-if="!isCorrectAnswer(answer, goal) && isChoseAnswer(answer, goal)" style="margin-left: 10px" name="fail" />
          </div>
        </div>
      </div>
    </template>
    <div v-if="!isQuestComplete" class="drops_works_card_bar">
      <div
        class="drops_works_card_fill"
        style="transform: translate(-0%, 0);"
        :style="{
          transform:
            'translate(' +
            ((quest.completionCount / quest.completionTarget) * 100 - 100) +
            '%,0)',
        }"
      />
    </div>
    <div class="drops_works_card_info">
      <div class="section">
        <div class="drops_works_crown">
          <i class="sp-ic-sm-drops-crown" />
        </div><p class="drops_works_crown_title" :class="quest.questStatus === QUEST_STATUS_DOING ? 'hub_drops_works_crown_title_doing' : 'hub_drops_works_crown_title_completed'">
          {{ getTextReward }}:&nbsp;<span>{{ getTextRewardValue() }}</span>
        </p>
      </div>
      <template v-if="!isQuestComplete">
        <!-- <p class="drops_works_crown_achievement">
          {{ quest.completionCount }}/{{ quest.completionTarget }}
        </p> -->
        <div v-if="quest.questType === QUEST_TYPE_SUBMIT_SCORE" class="hub_quest_card_action">
          <div class="quest_custom_button quest_btn_submit" :class="{quest_btn_loading_submit: loadingSubmitScore}" :style="'background:' + hubDropsTheme" @click.stop.prevent="handleSubmitScore()">Submit<div v-if="loadingSubmitScore" id="loaderSaving" /></div>
        </div>
        <div v-if="quest.questType === QUEST_TYPE_QUESTION" class="hub_quest_card_action">
          <div class="quest_custom_button quest_btn_submit" :class="{quest_btn_loading_submit: loadingSubmitAnswer}" :style="'background:' + hubDropsTheme" @click.stop.prevent="handleSubmitAnswer()">Submit Answer<div v-if="loadingSubmitAnswer" id="loaderSaving" /></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import { HubMixin } from '../../../mixins/hub';
import { ModalMixin } from '../../../mixins/modal';
import SvgIcon from '../../../components/shared/icons/index';

export default {
  components: { SvgIcon },
  mixins: [component, ModalMixin, HubMixin],
  props: {
    quest: {
      type: [Array, Object],
      default() {
        return {};
      },
    },
    submitQuest: {
      type: Function,
      default() {
        return {};
      },
    },
    dropId: {
      type: [String, Number],
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      QUEST_STATUS_DOING: 0,
      QUEST_STATUS_PENDING: 1,
      QUEST_STATUS_APPROVED: 2,
      QUEST_STATUS_DENIED: 3,
      QUEST_TYPE_SUBMIT_SCORE: 'App\\Quests\\Goals\\HubGoals\\ManualApproveGoal',
      QUEST_TYPE_QUESTION: 'App\\Quests\\Goals\\HubGoals\\QuizGoal',
      choosingAnswer: [],
      scoreSubmit: '',
      fileUpload: '',
      fileNameUpload: 'No File Chosen',
      loadingSubmitScore: false,
      loadingSubmitAnswer: false,
    };
  },
  computed: {
    isQuestComplete() {
      if (this.quest.questStatus !== this.QUEST_STATUS_DOING) {
        return true;
      }
      return false;
    },
    getTextReward() {
      if (this.quest.questType === this.QUEST_TYPE_SUBMIT_SCORE) {
        if (this.quest.questStatus === this.QUEST_STATUS_DOING || this.quest.questStatus === this.QUEST_STATUS_PENDING) {
          return 'Reward';
        } else {
          return 'Rewarded';
        }
      } else if (this.quest.questType === this.QUEST_TYPE_QUESTION) {
        if (this.quest.questStatus === this.QUEST_STATUS_DOING) {
          return 'Reward';
        } else {
          return 'Rewarded';
        }
      }
      return 'Reward';
    },
    getPointReward() {
      if (this.quest.questStatus === this.QUEST_STATUS_DENIED) {
        return 0;
      }
      return this.quest.rewardAmount;
    },
    getSponsorDarkTheme() {
      return this.quest.sponsorImageDark;
    },
    getSponsorLightTheme() {
      return this.quest.sponsorImage;
    },
  },
  methods: {
    isCorrectAnswer(answer, goal) {
      if (this.quest.questStatus === this.QUEST_STATUS_DOING) {
        return false;
      }
      const answerArr = goal.answerQuestion.split('|');
      if (!parseInt(goal.answerQuestion) || ((answerArr.includes(answer.trim())) || (goal.answerQuestion.trim() === '' && this.isChoseAnswer(answer, goal)))) {
        return true;
      }
      return false;
    },
    isChoseAnswer(answer, goal) {
      if (this.quest.questStatus === this.QUEST_STATUS_DOING) {
        return false;
      }
      /* if (goal.submittedValue && goal.submittedValue.trim() === answer.trim()) {
        return true;
      }*/
      if (goal.submittedValue.includes(answer.trim())) {
        return true;
      }
      return false;
    },
    handleChooseAnswer(answer, goal) {
      if (this.quest.questStatus !== this.QUEST_STATUS_DOING) {
        return;
      }
      if (goal.allowMultipleChoice) {
        if (!this.choosingAnswer.includes(answer)) {
          this.choosingAnswer.push(answer);
        } else {
          this.removeFromList(this.choosingAnswer, answer);
        }
      } else {
        this.choosingAnswer = [];
        this.choosingAnswer.push(answer);
      }
    },
    removeFromList(list, value) {
      const index = list.indexOf(value);
      if (index > -1) {
        list.splice(index, 1);
      }
    },
    handleChooseFile(event) {
      var files = event.target.files;
      if (files && files[0]) {
        this.fileUpload = files[0];
        this.fileNameUpload = files[0].name;
      }
    },
    async handleSubmitScore() {
      if (!this.appConfig.auth_check) {
        this.showModalLogin();
        sessionStorage.setItem('action_before_register', 'join_hub');
        return;
      }
      if (this.loadingSubmitScore) {
        return;
      }
      if ((!this.scoreSubmit || this.scoreSubmit === '' || !this.scoreSubmit.replace(/\s/g, '').length) && this.quest.goals[0] && this.quest.goals[0].allowInput){
        this.showModalBoomMsg('Please input an answer to submit this challenge!');
        return;
      }
      if (this.quest.goals[0].allowUpload && (!this.fileUpload || this.fileUpload === '')) {
        this.showModalBoomMsg('Please attach a screenshot to submit this challenge!');
        return;
      }
      this.loadingSubmitScore = true;
      var data = this.initDataSubmitQuest();
      await this.submitQuest(data, this.resetData);
      this.loadingSubmitScore = false;
    },
    async handleSubmitAnswer() {
      if (!this.appConfig.auth_check) {
        this.showModalLogin();
        sessionStorage.setItem('action_before_register', 'join_hub');
        return;
      }
      if (this.loadingSubmitAnswer) {
        return;
      }
      if (this.choosingAnswer.length === 0){
        this.showModalBoomMsg('Please choose an answer to submit this challenge!');
        return;
      }
      this.loadingSubmitAnswer = true;
      var data = this.initDataSubmitQuest();
      await this.submitQuest(data, this.resetData);
      this.loadingSubmitAnswer = false;
    },
    initDataSubmitQuest() {
      return {
        id: this.quest.id,
        drop_id: this.dropId,
        goal: this.quest.questType,
        quest: JSON.stringify(this.quest),
        submitted_screenshot: this.fileUpload,
        submitted_value: this.getSubmittedValue(),
      };
    },
    getSubmittedValue() {
      var submittedValue = '';
      if (this.quest.questType === this.QUEST_TYPE_SUBMIT_SCORE) {
        submittedValue = this.scoreSubmit;
      } else if (this.quest.questType === this.QUEST_TYPE_QUESTION) {
        submittedValue = JSON.stringify(this.choosingAnswer);
      }
      return submittedValue;
    },
    getTextRewardValue() {
      if (this.quest.rewardType === 'cakes') {
        if (parseInt(this.getPointReward) === 1) {
          return this.getPointReward + ' cake';
        } else {
          return this.getPointReward + ' cakes';
        }
      } else if (this.quest.rewardType === 'crowns') {
        if (parseInt(this.getPointReward) === 1) {
          return this.getPointReward + ' crown';
        } else {
          return this.getPointReward + ' crowns';
        }
      } else if (this.quest.rewardType === 'points') {
        if (parseInt(this.quest.rewardAmount) === 1) {
          return this.getPointReward + ' ' + this.quest.rewardPointTexts['single_point'];
        } else {
          return this.getPointReward + ' ' + this.quest.rewardPointTexts['multiple_points'];
        }
      }
    },
    resetData() {
      this.choosingAnswer = [];
      this.scoreSubmit = '';
      this.fileUpload = '';
      this.fileNameUpload = 'No File Chosen';
      if (document.getElementById('quest_attach_file')) {
        document.getElementById('quest_attach_file').value = '';
      }
    },
  },
};
</script>

<style>
  .goal-completed {
    text-decoration: line-through;
    display: list-item;
  }
  .goal-completed::before{
    content: none;
  }
</style>
